import React, { Dispatch, SetStateAction } from "react";
import { IUserDetails } from "../../exports/interfaces";
import useMobile from "../../hooks/useMobile";
import { useNavigate } from "react-router";
import UserFilters from "./UserFilters";
import UserTable from "./UserTable";
import { usePermission } from "../../hooks/usePermission";
import { FilePlus2 } from "lucide-react";

const UserList = ({
  user,
  setUser,
}: {
  user: IUserDetails[];
  setUser: Dispatch<SetStateAction<IUserDetails[]>>;
}) => {
  const isMobile = useMobile();
  const navigate = useNavigate();
  const { canCreate } = usePermission();

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3>User</h3>
          <small>MANAGE SYSTEM USERS, ROLES AND ACCESS</small>
        </div>

        {canCreate("Users") && (
          <button
            className="btn px-3 btn-badge"
            onClick={() => navigate("/user/add")}
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <FilePlus2 size={20} />
            </i>
            {!isMobile && "Add New User"}
          </button>
        )}
      </div>
      <UserFilters />
      <UserTable user={user} setUser={setUser} />
    </>
  );
};

export default UserList;
